import React from 'react'
import { RouteObject } from 'react-router-dom'
import { MainLayout } from '@components/layout/MainLayout'
import PageNotFound from '@pages/PageNotFound/PageNotFound'

/**
 * Miscellaneous routes that don't fit into other categories
 * Includes home page, general routes, etc.
 */
export const errorRoutes: RouteObject[] = [
  {
    path: '/',
    element: <MainLayout themeSwitcher />,
    children: [
      // 👇 Catch-all must go last both here and in router.tsx
      { path: '*', element: <PageNotFound /> },
    ],
  },
]
